<div class="loading-container">
  <mat-spinner diameter="32"></mat-spinner>
  <p>
    The inspection details will be displayed here once the inspection is created
    in EYE. Please wait for a few seconds.
  </p>
</div>
